<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-12/12 px-4">
      <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
        <div class="rounded-t bg-white mb-0 px-6 py-6">
          <div class="text-center flex justify-between">
            <h6 class="text-blueGray-700 text-xl font-bold">Change Password</h6>
            <button
              class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              type="button" @click="onSubmit(client)">
              Submit
            </button>
          </div>
        </div>
        <div class="flex-auto px-4 lg:px-10 py-10 pt-0">

          <div class="w-full lg:w-12/12 px-4 mt-3" v-if="alertType != ''">
            <div class="text-white px-4 py-2 border-0 rounded relative mb-4"
              v-bind:class="{ 'bg-emerald-500': alertType == 'Success', 'bg-red-500': alertType == 'Failed' }">
              <span class="text-m inline-block mr-5 align-middle">
                <i class="fas fa-bell"></i>
              </span>
              <span class="inline-block align-middle mr-8">
                <b class="capitalize">{{ alertType }}!</b> {{ alertMessage }}
              </span>
              <button
                class="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-2 mr-6 outline-none focus:outline-none">
                <span>×</span>
              </button>
            </div>
          </div>
          <div class="flex flex-wrap mt-3">
            <div class="w-full lg:w-6/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                  Old Password
                </label>
                <input type="password" v-model="client.oldpassword" name="oldpassword"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
              </div>
            </div>
            <div class="w-full lg:w-6/12 px-4">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                  New Password
                </label>
                <input type="password" v-model="client.newpassword" name="newpassword"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { UseAppStore } from '@/stores/AppStore';
import UserDataService from "@/services/UserDataService";

export default {
  setup() {
    const appStore = UseAppStore();
    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("api-management", "Change Password", "/admin/change-password")
    return {
      appStore
    }
  },
  data() {
    return {
      alertType: '',
      alertMessage: '',
      client: {},
      isShow: false
    }
  },
  components: {

  },
  methods: {
    redirectBack() {
      this.$router.replace('/admin/dashboard')
    },
    onSubmit(data) {
      UserDataService.changepassword(data)
        .then(() => {
          this.alertType = 'Success'
          this.alertMessage = 'Password successfuly Updated'
          this.countDownTimer(3, this.redirectBack)
        })
        .catch(e => {
          var pathname = document.location.pathname
          var unauthorized = true

          unauthorized = (e.response != null && (e.response.status == 401 || e.response.data['code'] == 401))

          if ((pathname != 'auth/login' && pathname != 'auth/register') && unauthorized) {
            localStorage.removeItem('user')
            localStorage['flash'] = 'Please re-login to continue'
            document.location = ''
          } else {
            this.alertType = 'Failed'
            this.alertMessage = e.response.data.code_message
            this.countDownTimer(3)
            console.log(e);
          }

        });
    },
    countDownTimer(countDown, callback) {
      if (countDown > 0) {
        setTimeout(() => {
          countDown -= 1
          this.countDownTimer(countDown, callback)
        }, 1000)
      } else {
        this.alertType = ''
        if (callback != undefined) {
          callback()
        }
      }
    }
  }
};
</script>
